import React, { useEffect, useState } from 'react'
import { Drawer, Card, Button, Form, Row, Col, Input, Icon } from 'antd'
import {
  DisplayDate,
  formItemLayout, InputBox,
  NotificationBox
} from '../../../../components/_utils/appUtils'
import { useDispatch } from 'react-redux'
import { ChooseEmailModal, chooseEmailModalFxn } from '../../../../components/_utils/appUtils'
import GetEachFormFields from '../../../../components/_utils/appFormUtils'
import { OnlinePublishAbstract } from '../actions'
import moment from 'moment'

let doiNo = '10.18805'
let shortNameObj = {
  'Legume Research': '',
  'Indian Journal of Agricultural Research': 'IJARe',
  'Indian Journal of Animal Research': 'IJAR',
  'Agricultural Science Digest': 'ag',
  'Asian Journal of Dairy and Food Research': 'ajdfr',
  'Bhartiya Krishi Anusandhan Patrika': '',
  'Agricultural Reviews': 'ag'
}

const OnlinePublishAbstractDrawer = (props) => {
  let {
    children,
    form: { getFieldDecorator, setFieldsValue },
    callback = null,
    abstract, // Changed from article
    visible,
    onClose,
    edit
  } = props
  const dispatch = useDispatch()

  useEffect(() => {
    setTimeout(() => {
      setFormData()
    }, 1000)
  }, [])

  let setFormData = () => {
    let { abstract, edit } = props
    if (edit) {
      props.form.setFieldsValue({
        onlinePublishedDate: moment(abstract.onlinePublishedDate),
        doiNumber: abstract.doiNumber
      })
      setAttachment({
        finalAbstractAttachmentWithDoi: abstract.finalAbstractAttachmentWithDoi && abstract.finalAbstractAttachmentWithDoi.path ? abstract.finalAbstractAttachmentWithDoi.path : ''
      })
    } else {
      // THE FIX: Added `|| ''` here!
      let journalDoi = shortNameObj[abstract.journal] || ''

      if (journalDoi) {
        journalDoi = journalDoi + '.'
      }

      props.form.setFieldsValue({
        onlinePublishedDate: moment(),
        doiNumber: `${doiNo}/${journalDoi}${abstract.abstractNo || abstract.onlineAbstractId}`
      })
    }
  }

  let [visibleDrawer, setVisibleDrawer] = useState(false)
  let [FinalAbstractAttachmentWithDOI, setFinalAbstractAttachmentWithDOI] = useState({})

  let [attachment, setAttachment] = useState({
    finalAbstractAttachmentWithDoi: ''
  })

  const events = {
    show: (event) => {
      setVisibleDrawer(true)
    },
    hide: (event) => {
      setVisibleDrawer(false)
    }
  }

  const inputSchema = {
    fields: [
      {
        label: 'Date',
        key: 'onlinePublishedDate',
        required: true,
        placeholder: 'Date of Enter',
        type: 'date'
      },
      {
        title: 'DOI generated',
        key: 'doiNumber'
      },
      {
        label: 'Abstract Attachment with DOI',
        customField: (
          <InputBox title={`Abstract Attachment with DOI`} className={'rowFlex'}>
            <Input type={'file'} name={'finalAbstractAttachmentWithDoi'} id={'finalAbstractAttachmentWithDoi'}
                   className={'form-control'}
                   onChange={(e) => {
                     let { name, files } = e.target
                     if (files && files.length) {
                       setFinalAbstractAttachmentWithDOI(files[0])
                     }
                   }} />
            {edit && attachment && attachment.finalAbstractAttachmentWithDoi ?
              <a className={'linkBtn'} target={'_blank'} href={`${attachment.finalAbstractAttachmentWithDoi}`}>
                <Icon type={'eye'} />
              </a> : null}
          </InputBox>
        )
      }
    ]
  }

  const handleSubmit = e => {
    const { form, abstract } = props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      chooseEmailModalFxn({
        title: 'Approve Abstract',
        callback: async (email) => {
          let fd = new FormData()
          let obj = {
            abstractId: abstract._id,
            ...valData,
            fromEmail: email,
            template: 'OnlinePublishTemplate',
            journalId: abstract.journal || abstract.journalId
          }
          if (!edit) {
            obj.status = 'Online Publish'
          }
          fd.append('obj', JSON.stringify(obj))
          fd.append('finalAbstractAttachmentWithDoi', FinalAbstractAttachmentWithDOI)
          let { success } = await dispatch(OnlinePublishAbstract(fd))
          if (success) {
            onClose()
            if (callback) {
              callback()
            }

            dispatch({ type: 'START_LOAD_ABSTRACT' })
            events.hide()
          }
        }
      })
    })
  }

  return (
    <>
      <div onClick={() => events.show()}>
        {children}
      </div>
      <Drawer
        title={`Online Publish Abstract | Abstract No. ${abstract.abstractNo || abstract.onlineAbstractId}`}
        width={'70%'}
        visible={visible}
        placement='right'
        onClose={onClose}>
        <Card>
          <Form onSubmit={handleSubmit} hideRequiredMark className={'inputForm'}>
            <Row gutter={16}>
              {inputSchema.fields.map((item, key) => {
                return (
                  <Col span={item.span ? item.span : 8} key={key}>
                    {item.customField ? item.customField :
                      <GetEachFormFields
                        item={item}
                        getFieldDecorator={getFieldDecorator}
                        formItemLayout={formItemLayout} />}
                  </Col>
                )
              })}
              <Col span={24}>
                <Form.Item style={{ marginTop: 40 }}>
                  <Button type='primary' htmlType='submit'>
                    Submit
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Card>
      </Drawer>
    </>
  )
}

const WrappedForm = Form.create()(OnlinePublishAbstractDrawer)

export default WrappedForm